module.exports = __webpack_public_path__ + "media/images/admin/icons/book-1eb461c1714bea41b70d160ad25dc9dc.svg";